import { RootState } from '@checkout/state';
import { Epic } from 'redux-observable';
import 'rxjs/add/operator/map';
import { ChangeStepSuccessAction, RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import { changeStepSuccess } from './../reducers/checkout';

export const changeStepEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.CHANGE_STEP_REQUEST)
    .map((action: ChangeStepSuccessAction) => changeStepSuccess({ step: action.payload.step }));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/steps.ts